/**
 * High Achievers Texas — Brand logo (script wordmark).
 * Source PNG has a solid black background. We use mix-blend-mode: screen so
 * the black drops out against any darker background — clean transparency with
 * no halo artifacts from manual alpha keying.
 */
export default function HALogo({ className = "", title = "High Achievers Texas" }) {
  return (
    <img
      src="/high-achievers-logo.png"
      alt={title}
      title={title}
      className={className}
      draggable={false}
      style={{ mixBlendMode: "screen" }}
    />
  );
}
